<div class="tab-container">
  @if (item().icon) {
    <mat-icon [svgIcon]="item().icon" class="nml-3 mr-6 nmt-4 nmb-4" />
  }

  <span
    class="twc-typography-body-2-medium"
    [class.twc-color-primary-typeface]="item().active"
    >{{ item().title }}</span
  >

  @if (item().menuItems && item().active) {
    <twc-item-menu
      class="display-flex ml-4"
      [actions]="item().menuItems"
      [actionArgument]="menuItemArgument()"
      [itemMenuStyle]="ItemMenuStyle.ICON"
    />
  }
  @if (item().badgeNumber) {
    <twc-badge
      class="display-block ml-4"
      [count]="item().badgeNumber"
      [color]="item().badgeColor ?? 'primary'"
    />
  }
</div>
